// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ChartCollectionIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ChartCollectionIcon" ref={forwardedRef} {...props}>
      <path d="M12 3H4.01A1.004 1.004 0 0 0 3 4v9h1.514V4.499H12z" />
      <path d="M6 6.996a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zm1.5 8.5h1.75V11h1.5v4.496h1.5V9.5h1.5v5.997h1.75v-8h-8z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ChartCollectionIcon = /* @__PURE__ */ Object.assign(
  ChartCollectionIconComponent,
  { displayName: 'ChartCollectionIcon' },
);
